export default "__VITE_ASSET__BIsk2yNY__"